export const orderEmailTemplate = {
  subject: '<report_type> <sales_reference>',
  body: `
      Hei <contact_firstname>, <br/>

      Takk for ordren. Vedlagt finner du vår <report_type> <order_number> <sales_reference><br/>
      Skulle det være noe mer vi kan bistå med, så ikke nøl med å ta kontakt.<br/>
      Håper du er fornøyd, og ser frem til å høre fra deg snart igjen.<br/><br/>
      `
}
export const offerEmailTemplate = {
  subject: 'Kilab tilbud <offer_number> <sales_reference>, <your_reference>',
  body: `
  Hei <contact_firstname>,<br/>

  Vi takker for henvendelsen, og har gleden av å tilby i henhold til vedlagt tilbud <offer_number> <sales_reference>.<br/>
  Vedlagt er også våre salgs og leveringsbetingelser, samt eventuelle datablader. <br/>
  Skulle du ha ytterligere spørsmål er det bare å ta kontakt. <br/>
  Vi ser frem til å motta deres ordre.<br/>
  `
}
export const invoiceEmailTemplate = {
  subject: 'Kilab faktura {{invoice_number}}, {{your_reference}}',
  body: `
  Hei,<br/>

  Vedlagt ligger faktura {{invoice_number}} på Deres bestilling {{your_reference}}.<br/>
  Vennligst betal ved forfall i henhold til faktura.<br/>
  Vi takker for ordren, og håper å høre fra dere igjen. Ved spørsmål til vedlagt faktura, send epost til invoice@kilab.no.<br/>
  `
}
export const creditNoteEmailTemplate = {
  subject: 'Kilab kreditnota {{invoice_number}}, {{your_reference}}',
  body: `
  Hei,<br/>

  Vedlagt ligger kreditnota {{invoice_number}} på Deres bestilling {{your_reference}}.<br/>
  Vennligst betal ved forfall i henhold til kreditnota.<br/>
  Vi takker for ordren, og håper å høre fra dere igjen. Ved spørsmål til vedlagt kreditnota, send epost til invoice@kilab.no.<br/>
  `
}
export const footer = `
Vennlig hilsen / Best regards<br/>

<logo here><br/>

Majorvegen 22<br/>
2030 Nannestad<br/>
Norge<br/>
Tlf +47 63942120`

export const logo = 'https://kilabapi.apphouse.no/kilab_logo.png'

export const getFooter = () => {
  return footer.replace('<logo here>', `<img src='${logo}' />`)
}

export const getOrderTemplate = (type, orderModel) => {
  if (!type) type = ''
  const subject = orderEmailTemplate.subject
    .replace('<report_type>', type)
    .replace('<sales_reference>', orderModel.salesreference || '')

  const body = orderEmailTemplate.body
    .replace('<report_type>', type.toLowerCase())
    .replace('<contact_firstname>', orderModel.contactname)
    .replace('<order_number>', orderModel.number)
    .replace('<sales_reference>', orderModel.salesreference || '')
    .replace('<footer>', footer)
    .replace('<logo here>', `<img src='${logo}' />`)

  return { subject, body }
}
export const getOfferTemplate = (orderModel) => {
  const subject = offerEmailTemplate.subject
    .replace('<offer_number>', orderModel.number)
    .replace('<sales_reference>', orderModel.salesreference || '')
    .replace('<your_reference>', orderModel.yourreference ? 'ref ' + orderModel.yourreference : '')

  const body = offerEmailTemplate.body
    .replace('<contact_firstname>', orderModel.contactname)
    .replace('<offer_number>', orderModel.number)
    .replace('<sales_reference>', orderModel.salesreference || '')
    .replace('<footer>', footer)
    .replace('<logo here>', `<img src='${logo}' />`)

  return { subject, body }
}
export const getInvoiceTemplate = (invoicerModel) => {
  const subject = invoiceEmailTemplate.subject
  // .replace('<invoice_number>', invoicerModel.number || '')
  // .replace('<your_reference>', invoicerModel.your_reference ? 'ref ' + invoicerModel.your_reference || '' : '')

  const body = invoiceEmailTemplate.body
    // .replace('<invoice_number>', invoicerModel.number || '')
    // .replace('<your_reference>', invoicerModel.your_reference || '')
    .replace('<footer>', footer)
    .replace('<logo here>', `<img src='${logo}' />`)
  return { subject, body }
}

export const getCreditNoteTemplate = (invoicerModel) => {
  const subject = creditNoteEmailTemplate.subject
  // .replace('<invoice_number>', invoicerModel.number || '')
  // .replace('<your_reference>', invoicerModel.your_reference ? 'ref ' + invoicerModel.your_reference || '' : '')

  const body = creditNoteEmailTemplate.body
    // .replace('<invoice_number>', invoicerModel.number || '')
    // .replace('<your_reference>', invoicerModel.your_reference || '')
    .replace('<footer>', footer)
    .replace('<logo here>', `<img src='${logo}' />`)
  return { subject, body }
}
